export default "__VITE_ASSET__2fff0dd0__"